import { StatusCodes } from 'http-status-codes';
/**
 * Throws an Http exception.
 */
export class HttpException extends Error {
    /**
     * @inheritDoc
     */
    constructor(message, status) {
        super(message);
        this.status = status || this.statusCode;
    }
    /**
     * Returns the exception name.
     */
    get name() {
        return this.constructor.name;
    }
    /**
     * Returns the status code of the exception.
     *
     * @default 500
     */
    get statusCode() {
        return this.status || StatusCodes.INTERNAL_SERVER_ERROR;
    }
}
//# sourceMappingURL=http.exception.js.map